import React from 'react';
import './DespreNoi.css';

function DespreNoi() {
    return (
        <div className="despre-noi-container">
            {/* Hero Section */}
            <div className="hero-section-despre">
                <div className="hero-content-despre">
                    <h1 className="despre-noi-title">Despre noi</h1>
                    <p className="hero-subtitle">Centrul medical de excelență pentru sănătatea dumneavoastră</p>
                </div>
            </div>

            <div className="despre-noi-content">

                <div className="despre-noi-section">
                    <div className="section-header">
                        <div className="section-icon">🎯</div>
                        <h2>Misiunea noastră</h2>
                    </div>
                    <p>
                        Evoo Medical reprezintă un centru medical modern dedicat sănătății și bunăstării pacienților noștri.
                        Ne străduim să oferim servicii medicale de cea mai înaltă calitate, folosind cele mai noi tehnologii
                        și metode de tratament disponibile.
                    </p>
                </div>

                <div className="despre-noi-section">
                    <div className="section-content-with-image">
                        <div className="section-text">
                            <div className="section-header">
                                <div className="section-icon">👥</div>
                                <h2>Echipa noastră</h2>
                            </div>
                            <p>
                                Echipa noastră este formată din medici specialiști cu experiență vastă în diverse domenii medicale,
                                asistente medicale dedicate și personal administrativ profesionist. Toți membrii echipei noastre
                                sunt dedicați misiunii de a oferi îngrijire medicală excelentă și suport complet pacienților.
                            </p>
                        </div>
                        <div className="section-image">
                            <img src="https://images.unsplash.com/photo-1551190822-a9333d879b1f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Echipa medicală Evoo" />
                        </div>
                    </div>
                </div>

                <div className="despre-noi-section">
                    <div className="section-header">
                        <div className="section-icon">⭐</div>
                        <h2>Valorile noastre</h2>
                    </div>
                    <div className="valori-grid">
                        <div className="valoare-item">
                            <div className="valoare-icon">🏆</div>
                            <h3>Calitate</h3>
                            <p>Oferim servicii medicale de cea mai înaltă calitate folosind echipamente moderne și tehnologii avansate.</p>
                        </div>
                        <div className="valoare-item">
                            <div className="valoare-icon">❤️</div>
                            <h3>Empatie</h3>
                            <p>Înțelegem nevoile și preocupările pacienților noștri, oferind suport emoțional și îngrijire personalizată.</p>
                        </div>
                        <div className="valoare-item">
                            <div className="valoare-icon">💡</div>
                            <h3>Inovație</h3>
                            <p>Implementăm constant noi tehnologii și metode de tratament pentru a asigura cele mai bune rezultate.</p>
                        </div>
                        <div className="valoare-item">
                            <div className="valoare-icon">🛡️</div>
                            <h3>Integritate</h3>
                            <p>Operăm cu transparență și etică în toate aspectele activității noastre medicale.</p>
                        </div>
                    </div>
                </div>

                <div className="despre-noi-section">
                    <div className="section-content-with-image">
                        <div className="section-text">
                            <div className="section-header">
                                <div className="section-icon"></div>
                                <h2>Facilitățile noastre</h2>
                            </div>
                            <p>
                                Clinica noastră este echipată cu cele mai moderne aparate medicale și beneficiază de un mediu
                                confortabil și sigur pentru toți pacienții. Dispunem de săli de consultație moderne, echipamente
                                de diagnostic avansate și un sistem de programare online eficient.
                            </p>
                        </div>
                        <div className="section-image">
                            <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Facilități medicale Evoo" />
                        </div>
                    </div>
                </div>

                <div className="despre-noi-section">
                    <div className="section-header">
                        <div className="section-icon"></div>
                        <h2>Contactați-ne</h2>
                    </div>
                    <p>
                        Suntem aici pentru dumneavoastră. Dacă aveți întrebări sau doriți să programați o consultație,
                        nu ezitați să ne contactați. Echipa noastră vă stă la dispoziție pentru orice informații suplimentare.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default DespreNoi;
